import { apiGet, apiPost, type QueryRecord } from './http-client';

/** Пути к domcrm-core /api/v1 (база в apiGet). */
export const EMBED_FITNESS = {
  sessions: '/fitness/sessions',
  book: (sessionId: number | string) => `/fitness/sessions/${sessionId}/book` as const,
  cancel: (sessionId: number | string) => `/fitness/sessions/${sessionId}/cancel` as const,
  checkIn: (sessionId: number | string) => `/fitness/sessions/${sessionId}/check-in` as const,
  waitlist: (sessionId: number | string) => `/fitness/sessions/${sessionId}/waitlist` as const
} as const;

/** Слот: канон `trainer_*` + alias `provider_*` (исполнитель; unified contract). */
export type FitnessSessionRow = {
  id: number;
  program_name: string;
  trainer_name: string;
  provider_id?: number;
  provider_name?: string;
  series_id?: number | null;
  starts_at: string;
  available_spots: number;
  status: string;
};

function withOrgQuery(path: string, orgId: number): string {
  const s = new URLSearchParams();
  s.set('organization_id', String(orgId));
  return `${path}?${s.toString()}`;
}

export type ListFitnessSessionsOptions = {
  /** RFC3339 — фильтр по `starts_at` (см. GET /fitness/sessions). */
  from?: string;
  to?: string;
};

export async function listFitnessSessions(
  orgId: number,
  accessToken: string | null,
  opts?: ListFitnessSessionsOptions
): Promise<unknown> {
  const q: QueryRecord = { organization_id: orgId };
  if (opts?.from) q.from = opts.from;
  if (opts?.to) q.to = opts.to;
  return apiGet<unknown>(EMBED_FITNESS.sessions, q, { accessToken, skipEmbedTokenRefresh: !accessToken });
}

export async function joinFitnessWaitlist(
  sessionId: number | string,
  orgId: number,
  accessToken: string | null
): Promise<unknown> {
  return apiPost<unknown>(withOrgQuery(EMBED_FITNESS.waitlist(sessionId), orgId), {}, { accessToken });
}

export async function bookFitnessSession(
  sessionId: number | string,
  orgId: number,
  accessToken: string | null
): Promise<unknown> {
  return apiPost<unknown>(withOrgQuery(EMBED_FITNESS.book(sessionId), orgId), {}, { accessToken });
}

export async function cancelFitnessSession(
  sessionId: number | string,
  orgId: number,
  accessToken: string | null
): Promise<unknown> {
  return apiPost<unknown>(withOrgQuery(EMBED_FITNESS.cancel(sessionId), orgId), {}, { accessToken });
}

export async function checkInFitnessSession(
  sessionId: number | string,
  orgId: number,
  userId: number,
  accessToken: string | null
): Promise<unknown> {
  return apiPost<unknown>(
    withOrgQuery(EMBED_FITNESS.checkIn(sessionId), orgId),
    { user_id: userId },
    { accessToken }
  );
}
